import { createApp } from 'vue'
import App from './App.vue'

import router from './router';
const app = createApp(App);
app.use(router)
app.mount('#app')


import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
// change language to chinese
TUITranslateService.changeLanguage("zh");
